import { i18n } from '../plugins/i18n'

// コメントへの返信の有無
export const replies = [
  { value: 'posted', name: '返信あり（掲載済み）', id: 'posted' },
  { value: 'in_progress', name: '返信あり（掲載待ち）', id: 'in_progress' },
  { value: 'error', name: '返信エラー', id: 'error' },
  { value: 'none', name: '返信なし', id: 'none' },
] as const

export const comments = [
  { value: true, name: '有', id: true },
  { value: false, name: '無', id: false },
] as const

export const emails = [
  { value: true, name: '有', id: true },
  { value: false, name: '無', id: false},
] as const

export const topic_type = [
  { value: 'STANDARD', name: i18n.t('models.gmb.topicType.standard'), id: 'STANDARD'},
  { value: 'EVENT', name: i18n.t('models.gmb.topicType.event'), id: 'EVENT'},
  { value: 'OFFER', name: i18n.t('models.gmb.topicType.offer'), id: 'OFFER'},
] as const
export const statuses = [
  { value: 'complete', name: i18n.t('models.gmb.postStatus.complete'), id: 'complete' },
  { value: 'closed', name: i18n.t('models.gmb.postStatus.closed'), id: 'closed' },
  { value: 'error', name: i18n.t('models.gmb.postStatus.error'), id: 'error' },
] as const

// @ts-expect-error 一旦。。
export const addAttributes = (item, type) => {
  item.type = type
  item.headText = i18n.te('models.filterItem.' + type + '.headText') ? i18n.t('models.filterItem.' + type + '.headText') : i18n.t('models.filterItem.all.headText')
  item.filterName = i18n.te('models.filterItem.' + type + '.filterName') ? i18n.t('models.filterItem.' + type + '.filterName') : item.label
  switch (type) {
  case 'comments':
    item.valueKey = 'value'
    break
  case 'ratings':
    item.valueKey = 'value'
    break
  case 'emails':
    item.valueKey = 'value'
    break
  case 'replies':
    item.valueKey = 'value'
    break
  case 'keyword_analysis_targets':
    item.valueKey = 'value'
    break
  case 'topic_types':
    item.valueKey = 'value'
    break
  case 'statuses':
    item.valueKey = 'value'
    break
  }

  return item
}
